
export interface TblProductoProdTermin{
    iddecinvproyectoprodtermin: number,
    iddecinvproyecto: number, 
    iddecinvtipoproductoesperado: number, 
    titulo: string, 
    anio: number 
    volumen: string, 
    paginas: string, 
    nombrerevista:string, 
    isindex: number, 
    bdrevista: number, 
    issn: string,
    factimpacto : string,
    editorial: string, 
    estadopublicacion: number, 
    especificacion: string, 
    url: string, 
    ultimoCambio: string,
    nevento: string, 
    levento: string, 
    fevento: string, 
    adjunto: string, 
    fechapublicacion: string, 
    resumen: string, 
    keys: string, 
    asistObjetiv: string 
    innovaVerific: string 
    logrosSistemac: string 
    retosComunic: string 
    idunidad: number, 
    tipolab: string, 
    marca: string, 
    modelo: string, 
    serie: string, 
    inventario: string, 
    estado: number, 
    frecuencia: number,
    fvencimiento: string, 
    doi: string, 
    iddecinvrevista: number,
    sjr: string, 
    cuartil: string, 
    aprobado: string, 
    iddecinvmotivoprodtermin: number, 
    observacionarpob: string, 
    idpublicacionpersona: number, 
    adjunto2: string,
    adjunto3: string, 
    adjunto4: string, 
    codigoproducto: string,
    tipotesis: string, 
    revisionpares: string,
    inventor: string,
    subclase: number,
    urlrevista: string,
    materiaintegradora: string,
    numerosolicitud: string,
    objgeneral: string,
    estadoproducto: string
}

export function getVoidProdcutoTerminado(): TblProductoProdTermin{
    return{
        iddecinvproyectoprodtermin: 0,
        iddecinvproyecto: 0, 
        iddecinvtipoproductoesperado: 0, 
        titulo: "", 
        anio: 0 ,
        volumen: "", 
        paginas: "", 
        nombrerevista:"", 
        isindex: 0, 
        bdrevista: 0, 
        issn: "",
        factimpacto : "",
        editorial: "", 
        estadopublicacion: 0, 
        especificacion: "", 
        url: "", 
        ultimoCambio: "",
        nevento: "", 
        levento: "", 
        fevento: "", 
        adjunto: "", 
        fechapublicacion: "", 
        resumen: "", 
        keys: "", 
        asistObjetiv: "" ,
        innovaVerific: "", 
        logrosSistemac: "" ,
        retosComunic: "" ,
        idunidad: 0, 
        tipolab: "", 
        marca: "", 
        modelo: "", 
        serie: "", 
        inventario: "", 
        estado: 0, 
        frecuencia: 0,
        fvencimiento: "", 
        doi: "", 
        iddecinvrevista: 0,
        sjr: "", 
        cuartil: "", 
        aprobado: "", 
        iddecinvmotivoprodtermin: 0, 
        observacionarpob: "", 
        idpublicacionpersona: 0, 
        adjunto2: "",
        adjunto3: "", 
        adjunto4: "", 
        codigoproducto: "",
        tipotesis: "", 
        revisionpares: "",
        inventor: "",
        subclase: 0,
        urlrevista: "",
        materiaintegradora: "N",
        numerosolicitud: "",
        objgeneral: "",
        estadoproducto: "C" 
    }
}

export function setProductoTerminado(data: any): TblProductoProdTermin{
    return{
        iddecinvproyectoprodtermin:data.iddecinvproyectoprodtermin?? 0,
        iddecinvproyecto:data.iddecinvproyecto?? 0, 
        iddecinvtipoproductoesperado:data.iddecinvtipoproductoesperado?? 0, 
        titulo:data.titulo?? "", 
        anio:data.anio?? 0 ,
        volumen:data.volumen?? "", 
        paginas:data.paginas?? "", 
        nombrerevista:data.nombrerevista??"", 
        isindex:data.isindex?? 0, 
        bdrevista:data.bdrevista?? 0, 
        issn:data.issn?? "",
        factimpacto :data.factimpacto ?? "",
        editorial:data.editorial?? "", 
        estadopublicacion:data.estadopublicacion?? 0, 
        especificacion:data.especificacion?? "", 
        url:data.url?? "", 
        ultimoCambio:data.ultimoCambio?? "",
        nevento:data.nevento?? "", 
        levento:data.levento?? "", 
        fevento:data.fevento?? "", 
        adjunto:data.adjunto?? "", 
        fechapublicacion:data.fechapublicacion?? "", 
        resumen:data.resumen?? "", 
        keys:data.keys?? "", 
        asistObjetiv:data.asistObjetiv?? "" ,
        innovaVerific:data.innovaVerific?? "", 
        logrosSistemac:data.logrosSistemac?? "" ,
        retosComunic:data.retosComunic?? "" ,
        idunidad:data.idunidad?? 0, 
        tipolab:data.tipolab?? "", 
        marca:data.marca?? "", 
        modelo:data.modelo?? "", 
        serie:data.serie?? "", 
        inventario:data.inventario?? "", 
        estado:data.estado?? 0, 
        frecuencia:data.frecuencia?? 0,
        fvencimiento:data.fvencimiento?? "", 
        doi:data.doi?? "", 
        iddecinvrevista:data.iddecinvrevista?? 0,
        sjr:data.sjr??0, 
        cuartil:data.cuartil?? "", 
        aprobado:data.aprobado?? "", 
        iddecinvmotivoprodtermin:data.iddecinvmotivoprodtermin?? 0, 
        observacionarpob:data.observacionarpob?? "", 
        idpublicacionpersona:data.idpublicacionpersona?? 0, 
        adjunto2:data.adjunto2?? "",
        adjunto3:data.adjunto3?? "", 
        adjunto4:data.adjunto4?? "", 
        codigoproducto:data.codigoproducto?? "",
        tipotesis:data.tipotesis?? "", 
        revisionpares:data.revisionpares?? "",
        inventor:data.inventor?? "" ,
        subclase: data.subclase??0,
        urlrevista: data.urlrevista??"",
        materiaintegradora: data.materiaintegradora??"",
        numerosolicitud: data.numerosolicitud??"",
        objgeneral: data.objgeneral??"",
        estadoproducto: data.estadoproducto??"N" 
    }
}

export function setProductoTerminadoImport(data: any): TblProductoProdTermin{
    return{
        iddecinvproyectoprodtermin:data.iddecinvproyectoprodtermin?? 0,
        iddecinvproyecto:data.iddecinvproyecto?? 0, 
        iddecinvtipoproductoesperado:data.iddecinvtipoproductoesperado?? 0, 
        titulo:data.titulo?? "", 
        anio:data.anio?? 0 ,
        volumen:data.volumen?? "", 
        paginas:data.paginas?? "", 
        nombrerevista:data.nombrerevista??"", 
        isindex:data.isindex?? 0, 
        bdrevista: 3799, 
        issn:data.issn?? "",
        factimpacto :data.factimpacto ?? "",
        editorial:data.editorial?? "", 
        estadopublicacion:data.estadopublicacion?? 0, 
        especificacion:data.especificacion?? "", 
        url:data.url?? "", 
        ultimoCambio:data.ultimoCambio?? "",
        nevento:data.nevento?? "", 
        levento:data.levento?? "", 
        fevento:data.fevento?? "", 
        adjunto:data.adjunto?? "", 
        fechapublicacion: "", 
        resumen:data.resumen?? "", 
        keys:data.keys?? "", 
        asistObjetiv:data.asistObjetiv?? "" ,
        innovaVerific:data.innovaVerific?? "", 
        logrosSistemac:data.logrosSistemac?? "" ,
        retosComunic:data.retosComunic?? "" ,
        idunidad:data.idunidad?? 0, 
        tipolab:data.tipolab?? "", 
        marca:data.marca?? "", 
        modelo:data.modelo?? "", 
        serie:data.serie?? "", 
        inventario:data.inventario?? "", 
        estado:data.estado?? 0, 
        frecuencia:data.frecuencia?? 0,
        fvencimiento: "", 
        doi:data.doi?? "", 
        iddecinvrevista:data.iddecinvrevista?? 0,
        sjr:data.sjr??0, 
        cuartil:data.cuartil?? "", 
        aprobado:data.aprobado?? "", 
        iddecinvmotivoprodtermin:data.iddecinvmotivoprodtermin?? 0, 
        observacionarpob:data.observacionarpob?? "", 
        idpublicacionpersona:data.idpublicacionpersona?? 0, 
        adjunto2:data.adjunto2?? "",
        adjunto3:data.adjunto3?? "", 
        adjunto4:data.adjunto4?? "", 
        codigoproducto:data.codigoproducto?? "",
        tipotesis:data.tipotesis?? "", 
        revisionpares:data.revisionpares?? "",
        inventor:data.inventor?? "" ,
        subclase: data.subclase??0,
        urlrevista: data.urlrevista??"",
        materiaintegradora: data.materiaintegradora??"",
        numerosolicitud: data.numerosolicitud??"",
        objgeneral: data.objgeneral??"",
        estadoproducto: data.estadoproducto??"N" 
    }
}

export function setProductoConferencia(data: any): TblProductoProdTermin{
    return{
        iddecinvproyectoprodtermin: 0,
        iddecinvproyecto:data.iddecinvproyecto?? 0, 
        iddecinvtipoproductoesperado:data.iddecinvtipoproductoesperado?? 0, 
        titulo:data.titulo?? "", 
        anio:data.anio?? 0 ,
        volumen: "", 
        paginas: "", 
        nombrerevista:"", 
        isindex:data.isindex?? 0, 
        bdrevista:data.bdrevista?? 0, 
        issn:data.issn?? "",
        factimpacto: "",
        editorial: "", 
        estadopublicacion: 0, 
        especificacion: "", 
        url: "", 
        ultimoCambio:data.ultimoCambio?? "",
        nevento: "", 
        levento: "", 
        fevento: "", 
        adjunto: "", 
        fechapublicacion:data.fechapublicacion?? "", 
        resumen: "", 
        keys: "", 
        asistObjetiv: "" ,
        innovaVerific: "", 
        logrosSistemac: "" ,
        retosComunic: "" ,
        idunidad: 0, 
        tipolab: "", 
        marca: "", 
        modelo: "", 
        serie: "", 
        inventario: "", 
        estado: 0, 
        frecuencia: 0,
        fvencimiento: "", 
        doi:data.doi?? "", 
        iddecinvrevista: 0,
        sjr: "", 
        cuartil:data.cuartil?? "", 
        aprobado:data.aprobado?? "", 
        iddecinvmotivoprodtermin: 0, 
        observacionarpob: "", 
        idpublicacionpersona: 0, 
        adjunto2: "",
        adjunto3: "", 
        adjunto4: "", 
        codigoproducto: "",
        tipotesis: "", 
        revisionpares: "",
        inventor: "",
        subclase: 0,
        urlrevista: "",
        materiaintegradora: "",
        numerosolicitud: "",
        objgeneral: "",
        estadoproducto: "C"  
    }
}

export interface ScopusPublicationDTO{
    autor:string,
    titulo:string,
    coverDate:string,
    coverDisplayDate:string,
    eid:string,
    publicationName:string,
    volumen:string,
    pageRange:string,
    citedCount:string,
    source:string,
    tipo:string,
    subtipo:string,
    issn:string,
    DOI:string,
    openAccess:string
}

export function setProductoScopus(row: any): TblProductoProdTermin{
    //console.log(row);
    return{
        iddecinvproyectoprodtermin: 0,
        iddecinvproyecto: 0, 
        iddecinvtipoproductoesperado:24, 
        titulo:row.titulo ?? "", 
        anio: 0 ,
        volumen: row.volumen ?? "", 
        paginas: "", 
        nombrerevista: row.publicationName ?? "", 
        isindex: 0, 
        bdrevista: 1, 
        issn:row.issn?? "",
        factimpacto: "",
        editorial: "", 
        estadopublicacion: 0, 
        especificacion: "", 
        url: "", 
        ultimoCambio: "",
        nevento: "", 
        levento: "", 
        fevento: "", 
        adjunto: "", 
        fechapublicacion: row.coverDate ?? "", 
        resumen: "", 
        keys: "", 
        asistObjetiv: "" ,
        innovaVerific: "", 
        logrosSistemac: "" ,
        retosComunic: "" ,
        idunidad: 0, 
        tipolab: "", 
        marca: "", 
        modelo: "", 
        serie: "", 
        inventario: "", 
        estado: 0, 
        frecuencia: 0,
        fvencimiento: "", 
        doi: row.DOI ?? "", 
        iddecinvrevista: 0,
        sjr: "", 
        cuartil: "", 
        aprobado: "", 
        iddecinvmotivoprodtermin: 0, 
        observacionarpob: "", 
        idpublicacionpersona: 0, 
        adjunto2: "",
        adjunto3: "", 
        adjunto4: "", 
        codigoproducto: "",
        tipotesis: "", 
        revisionpares: "",
        inventor: "" ,
        subclase: 0,
        urlrevista: "",
        materiaintegradora: "",
        numerosolicitud: "",
        objgeneral: "",
        estadoproducto: "N" 
    }
}